/**
 * Route registry.
 *
 * The app is a single-canvas SPA today; the scene is selected through the
 * viewport store rather than the URL. This module reserves the contract for a
 * future URL router so that store reducers and HUD buttons can already speak in
 * terms of stable scene identifiers.
 *
 * See docs/FRONTEND_PLAN.md.
 */

import type { SceneName } from '@/types';

export interface RouteDescriptor {
  readonly name: SceneName;
  readonly label: string;
  readonly path: `/${string}`;
  readonly description: string;
}

export const ROUTES: Readonly<Record<SceneName, RouteDescriptor>> = Object.freeze({
  globe: {
    name: 'globe',
    label: 'Globe',
    path: '/',
    description: 'Planet-scale topology overview.',
  },
});

export const ROUTE_LIST: readonly RouteDescriptor[] = Object.freeze(
  Object.values(ROUTES) as RouteDescriptor[],
);
